"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var paymentDisclaimerStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        container: {
            position: 'relative',
        },
        controlContainer: {
            display: 'table',
            marginBottom: 30,
        },
        controlCheckbox: {
            display: 'table-cell',
        },
        label: {},
        buttonWrapper: (_a = {
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            },
            _a[theme.breakpoints.down('xs')] = {
                alignItems: 'center',
            },
            _a),
        paymentDisclaimerLabel: {},
        icon: {},
        continueButton: {},
    });
}, { name: 'Checkout4_PaymentDisclaimer' });
exports.default = paymentDisclaimerStyles;
